import { AppRouter } from "./router";
import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { ToastContainer } from "./components/ui/Toast";
import { TourProvider } from "./components/tour";
import { UpdatePrompt } from "./pwa/UpdatePrompt";
import { InstallPrompt } from "./pwa/InstallPrompt";
import { CallDock } from "./components/voice/CallDock";
import { useSWNavigation } from "./hooks/useSWNavigation";

function App() {
  // Tocar o aviso de uma conversa abre ela no app que já está aberto, em
  // vez de só focar a janela onde ela estava.
  useSWNavigation();

  return (
    <>
      {/* Último recurso: pega o que estourar fora do layout (login, chunk
          que não carrega) e que de outro jeito viraria tela branca. */}
      <ErrorBoundary label="root">
        <AppRouter />
      </ErrorBoundary>
      <ToastContainer />
      <TourProvider />
      <UpdatePrompt />
      <InstallPrompt />
      {/* Acima do router de propósito: navegar no Desk não pode
          desmontar a chamada e derrubar a conexão WebRTC. */}
      <CallDock />
    </>
  );
}

export default App;
